<template>
    <div class="OrderList">
    <GlobalInfoBar title="换新商品管理" content="管理和查看换新商品，包括创建、上架、下架商品" />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <OrderFrom :machineType="machineType"/>
      </div>
      <div class="caseOrder">
          <OrderTable @getUnPayUserOrders="getUnPayUserOrders" :option="machineType"/>
      </div>
    </GlobalChunk>
  </div>
</template>

<script>
import _api from "@/utils/request";
import OrderFrom from "./Form"
import OrderTable from "./Table"
export default {
  name: "OrderList",
  components:{OrderFrom,OrderTable},
  data() {
    return {
      classList: null,
      merchantId: '',
      UnPayUserOrders: 0,
      machineType: [],
    };
  },
  created() {
    this.getAllMachineType()
  },
  methods: {
    getUnPayUserOrders(e) {
      this.UnPayUserOrders = e
    },
    //分类下拉
    getAllMachineType() {
      _api.typeSelect().then((res) => {
          this.machineType = res.data;
      });
    },
  }
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.OrderList {
  .caseOrder {
        margin: 0 5px;
        // background: #f5f6fa;
        border-radius: 10px;
    }
}
</style>
